import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';

import {AuthService} from '../auth/auth.service';
import {AuthPageManageService} from '../manage/page-manage/auth-page-manage.service';
import {ToolsService} from '../tools/tools.service';
import {SalemethodService} from "../api/salemethod/salemethod.service";

@Injectable({
  providedIn: 'root'
})
export class UserGuardService implements CanActivate {
  currSm: any;

  constructor(
    private authService: AuthService,
    private authPageServ: AuthPageManageService,
    public tools: ToolsService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<any> {

    const that = this;
    const urlName = next.url[0].path;

    that.currSm = this.tools.getStor(SalemethodService.TAG_STORAGE);

    return new Promise(function (resolve) {

      that.authService.checkIfAuth().then(function (data) {


        resolve(true);

      }).catch(function (error) {

        if (urlName === "endorder" && (!that.currSm || (that.currSm && !that.currSm.disable_authentification))) {


          that.authPageServ.goLogin("endorder");

          // resolve(true);
        } else {
          resolve(true);
        }
      });
    })
  }
}
